<template>
  <div style="color: black;font-size: 30px;padding-top: 10%">待开发</div>
</template>

<script>
  export default {
    name: "undo"
  }
</script>

<style scoped>

</style>
